export const LISTADO_REPORTE_CUPONES = 'LISTADO_REPORTE_CUPONES';
export const REPORTE_CUPONES_LOADING = 'REPORTE_CUPONES_LOADING';
export const REPORTE_CUPON_SELECCIONADO = 'REPORTE_CUPON_SELECCIONADO';
export const REPORTE_CUPONES_TOTALES = 'REPORTE_CUPONES_TOTALES';
export const REPORTE_CUPONES_RESUMEN = 'REPORTE_CUPONES_RESUMEN';
export const PAGINADO_REPORTE_CUPONES = 'PAGINADO_REPORTE_CUPONES';
export const OBTENER_USUARIOS = 'OBTENER_USUARIOS';
